const FacebookIcon = ({
  className = "",
  width = 20,
  height = 14,
  fill = "none",
}) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.4166 13.1991C23.4166 7.44914 18.75 2.78247 13 2.78247C7.24998 2.78247 2.58331 7.44914 2.58331 13.1991C2.58331 18.2408 6.16665 22.4387 10.9166 23.4075V16.3241H8.83331V13.1991H10.9166V10.595C10.9166 8.58455 12.5521 6.94914 14.5625 6.94914H17.1666V10.0741H15.0833C14.5104 10.0741 14.0416 10.5429 14.0416 11.1158V13.1991H17.1666V16.3241H14.0416V23.5637C19.3021 23.0429 23.4166 18.6054 23.4166 13.1991Z"
        fill="#438BBD"
      />
    </svg>
  );
};

export default FacebookIcon;
